export class TextosUndoChanges{
    encabezado: string;
    textoSi: string;
    textoNo: string;
    textoDescriptivo?: string;
}